<template>
    <v-card elevation="0" class="card-shadow my-4">
        <v-row class="pa-3">
            <v-col class="ml-2 align-self-center">
                <p class="card-info pa-0 ma-0">{{ $t("pay.no_card") }}.</p>
                <a @click="addCard()" class="add-card">{{ $t("pay.add") }}</a>
            </v-col>
            <v-col cols="3" class="align-self-center">
                <img :src="icons.noCreditCard" width="50" />
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import noCreditCard from "@/assets/img/no-cc.png";

export default {
    name: "NoCreditCardBox",
    props: ["addCard"],
    data() {
        return {
            icons: { noCreditCard },
        };
    },
};
</script>

<style scoped>
.card-info {
    font-size: 13px !important;
    color: #666666;
}
.add-card {
    font-size: 13px !important;
    text-decoration: underline;
}
</style>
